/**
 * Logos de proveedores (pagos + logística) servidos desde /public.
 * Paridad: hub /app/pagos y /app/logistica + checkout.
 */

const PAYMENT_LOGOS: Record<string, string> = {
  payway: "/payment-providers/payway.svg",
  mercadopago: "/payment-providers/mercadopago.svg",
  modo: "/payment-providers/modo.png",
  getnet: "/payment-providers/getnet.png",
  uala: "/payment-providers/uala.png",
  nave: "/payment-providers/nave.jpg",
  talo: "/payment-providers/talo.svg",
  sipago: "/payment-providers/sipago.svg",
};

const LOGISTICS_LOGOS: Record<string, string> = {
  shipnow: "/logistics-providers/shipnow.png",
  treggo: "/logistics-providers/treggo.png",
  andreani: "/logistics-providers/andreani.png",
  oca: "/logistics-providers/oca.svg",
  correo_argentino: "/logistics-providers/correo-argentino.svg",
  cabify: "/logistics-providers/cabify.png",
  uber_direct: "/logistics-providers/uber-direct.svg",
  pedidosya: "/logistics-providers/pedidosya.svg",
  rapiboy: "/logistics-providers/rapiboy.svg",
  zipnova: "/logistics-providers/zipnova.png",
  pickit: "/logistics-providers/pickit.svg",
  enviopack: "/logistics-providers/enviopack.png",
  zones: "/logistics-providers/zones.svg",
  radius: "/logistics-providers/radius.svg",
  entrega: "/logistics-providers/entrega.svg",
};

/** Aliases que llegan en carrierCode / id de cotización. */
const LOGISTICS_LOGO_ALIASES: Record<string, string> = {
  oca_epak: "oca",
  ocaepak: "oca",
  "oca-epak": "oca",
  correo: "correo_argentino",
  correoargentino: "correo_argentino",
  micorreo: "correo_argentino",
  uber: "uber_direct",
  uberdirect: "uber_direct",
  pedidos_ya: "pedidosya",
  "pedidos-ya": "pedidosya",
  peya: "pedidosya",
  rapi_boy: "rapiboy",
  "rapi-boy": "rapiboy",
};

function normalizeProviderKey(id: string): string {
  return id.trim().toLowerCase().replace(/[\s-]+/g, "_");
}

export function paymentProviderLogo(id: string): string | undefined {
  return PAYMENT_LOGOS[normalizeProviderKey(id)];
}

export function logisticsProviderLogo(id: string): string | undefined {
  const key = normalizeProviderKey(id);
  const canonical = LOGISTICS_LOGO_ALIASES[key] ?? key;
  return LOGISTICS_LOGOS[canonical];
}

/** Resuelve logo por id o por nombre visible del carrier (checkout). */
export function logisticsLogoFromCarrier(input: {
  carrierCode?: string | null;
  carrierName?: string | null;
  optionId?: string | null;
}): string | undefined {
  const code = input.carrierCode ? normalizeProviderKey(input.carrierCode) : "";
  if (code) {
    const direct = logisticsProviderLogo(code);
    if (direct) return direct;
  }
  const fromId = input.optionId?.split(":")[0];
  if (fromId) {
    const direct = logisticsProviderLogo(fromId);
    if (direct) return direct;
  }
  const name = (input.carrierName ?? "").toLowerCase();
  if (!name) return undefined;
  const hints: Array<[string, string]> = [
    ["pedidosya", "pedidosya"],
    ["pedidos ya", "pedidosya"],
    ["rapiboy", "rapiboy"],
    ["pickit", "pickit"],
    ["uber", "uber_direct"],
    ["oca", "oca"],
    ["correo", "correo_argentino"],
    ["andreani", "andreani"],
    ["shipnow", "shipnow"],
    ["treggo", "treggo"],
    ["cabify", "cabify"],
    ["zipnova", "zipnova"],
    ["enviopack", "enviopack"],
  ];
  for (const [needle, id] of hints) {
    if (name.includes(needle)) return logisticsProviderLogo(id);
  }
  return undefined;
}
